import React from 'react';
import "./style.css"

export default function Contactus() {
    return(
        <section class="contactus" id="contactus">
            <div class="container">
                <h2>צור קשר</h2>
                <form class="contact-form">
                    <div class="input-wrap form-group row"> 
                        <div class="col-md-6">
                            <input class="form-control" name="name" type="text" placeholder="מייל" required=""/> 
                        </div>
                        <div class="col-md-6">
                            <input class="form-control" name="email" type="email" placeholder="שם שלך" required=""/>
                        </div>
                    </div>
                    <textarea class="form-control col-md-12" name="message" placeholder="הודעה"></textarea>
                    <input class="contact__btn" type="submit" value="שלח"/>
                </form>
            </div>
        </section>

    );
}